import { TableBody, TableCell, TableRow } from "@windmill/react-ui";
import EditDeleteButton from "components/table/EditDeleteButton";
import React from "react";
import useToggleDrawer from "hooks/useToggleDrawer";
import OnewayPickupBasicRateDrawer from 'components/drawer/OnewayPickupDrawer'
import MainDrawer from "components/drawer/MainDrawer";
import DeleteModal from "components/modal/DeleteModal";
import ShowHideButton from "components/table/ShowHideButton";

const OnewayPickupBasicRateTable = ({
    OnewayPickupBasicRate,
    perpage,
    currentPage,
    hideEdit,
    hideDelete,
}) => {
    const { title, serviceId, handleModalOpen, handleUpdate } = useToggleDrawer();
    const onewaypickupdata = OnewayPickupBasicRate;
    return (
        <>
            <DeleteModal id={serviceId} title={title} />

            <MainDrawer>
                <OnewayPickupBasicRateDrawer id={serviceId} />
            </MainDrawer>

            <TableBody>
                {onewaypickupdata?.slice(0, perpage).map((data, index) => (
                    <React.Fragment key={data?.id}>
                        {Array.isArray(data.vehicle_type_id) &&
                            data.vehicle_type_id.map((vehicleId, vehicleIndex) => (
                                <TableRow key={`${data.id}-${vehicleIndex}`}>
                                    {/* SL / From / To — rowspan only once */}
                                    {vehicleIndex === 0 && (
                                        <>
                                            <TableCell
                                                rowSpan={data.vehicle_type_id.length}
                                                className="text-sm text-center"
                                            >
                                                {(currentPage - 1) * perpage + index + 1}
                                            </TableCell>

                                            <TableCell
                                                rowSpan={data.vehicle_type_id.length}
                                                className="text-sm text-center"
                                            >
                                                {data.from_city_name?.join(", ")}
                                            </TableCell>

                                            <TableCell
                                                rowSpan={data.vehicle_type_id.length}
                                                className="text-sm text-center"
                                            >
                                                {data.to_city_name?.join(", ")}
                                            </TableCell>
                                        </>
                                    )}

                                    {/* Vehicle Name */}
                                    <TableCell className="text-sm text-center">
                                        {data.vehicle_type_names?.[vehicleId] ?? "-"}
                                    </TableCell>

                                    {/* Min Rate */}
                                    <TableCell className="text-sm text-center">
                                        {data.min_rate?.[vehicleId] ?? "-"}
                                    </TableCell>

                                    {/* Min KM */}
                                    <TableCell className="text-sm text-center">
                                        {data.min_km?.[vehicleId] ?? "-"}
                                    </TableCell>

                                    {/* Extra KM */}
                                    <TableCell className="text-sm text-center">
                                        {data.extra_km?.[vehicleId] ?? "-"}
                                    </TableCell>

                                    {/* Status */}
                                    {vehicleIndex === 0 && (
                                        <TableCell
                                            rowSpan={data.vehicle_type_id.length}
                                            className="text-sm text-center"
                                        >
                                            <ShowHideButton
                                                id={data.id}
                                                status={data.status}
                                                Loading={true}
                                            />
                                        </TableCell>
                                    )}

                                    {/* Actions */}
                                    {vehicleIndex === 0 && (
                                        <TableCell
                                            rowSpan={data.vehicle_type_id.length}
                                            className="text-center"
                                        >
                                            <EditDeleteButton
                                                title="Oneway Pickup"
                                                id={data.id}
                                                handleUpdate={handleUpdate}
                                                handleModalOpen={handleModalOpen}
                                                hideDelete={hideDelete}
                                                hideEdit={hideEdit}
                                            />
                                        </TableCell>
                                    )}
                                </TableRow>
                            ))}
                    </React.Fragment>
                ))}
            </TableBody>




            {/* <TableBody>
                {onewaypickupdata?.slice(0, perpage).map((data, index) => (
                    <React.Fragment key={data?.id}>
                        {data["vehicle_type_id"].map((item, vehicleIndex) => (
                            <TableRow key={`${data.id}-${vehicleIndex}`}>
                                {vehicleIndex === 0 && (
                                    <>
                                        <TableCell
                                            rowSpan={data["vehicle_type_id"].length}
                                            className="text-sm text-center"
                                        >
                                            {(currentPage - 1) * perpage + index + 1}
                                        </TableCell>
                                        <TableCell
                                            rowSpan={data["vehicle_type_id"].length}
                                            className="text-sm text-center"
                                        >
                                            {data["name_of_airport"]}
                                        </TableCell>
                                    </>
                                )}

                                <TableCell className="text-sm text-center">
                                    {data["vehicle_type_names"][item]}
                                </TableCell>

                                <TableCell className="text-sm text-center">
                                    {data["min_rate"][item]}
                                </TableCell>

                                <TableCell className="text-sm text-center">
                                    {data["min_km"][item]}
                                </TableCell>

                                <TableCell className="text-sm text-center">
                                    {data["extra_km"][item]}
                                </TableCell>

                                <TableCell className="text-sm text-center">
                                    {data["prime"][item] + "%"}
                                </TableCell>


                                {vehicleIndex === 0 && (
                                    <TableCell
                                        className="text-sm text-center"
                                        rowSpan={data["vehicle_type_id"].length}
                                    >
                                        <ShowHideButton
                                            id={data.id}
                                            status={data.is_active}
                                            Loading={true}
                                        />
                                    </TableCell>
                                )}


                                {vehicleIndex === 0 && (
                                    <TableCell
                                        rowSpan={data["vehicle_type_id"].length}
                                        className="text-center"
                                    >
                                        <EditDeleteButton
                                            title={data["Airport Pickup"]}
                                            id={data.id}
                                            handleUpdate={handleUpdate}
                                            handleModalOpen={handleModalOpen}
                                            hideDelete={hideDelete}
                                            hideEdit={hideEdit}
                                        />
                                    </TableCell>
                                )}
                            </TableRow>
                        ))}
                    </React.Fragment>
                ))}
            </TableBody> */}
        </>
    );
};

export default OnewayPickupBasicRateTable;
